import {AutocompleteModule, DatepickerModule, PaginationMapsModule} from 'maps-angular-components';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PaginationModule, TabsModule} from "ngx-bootstrap";

import {CarteiraModule} from "../carteira/carteira.module";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDialogModule} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatTableModule} from "@angular/material/table";
import { ModalAlteracoesComponent } from './modal-alteracoes/modal-alteracoes.component';
import {NgModule} from '@angular/core';
import {NgStringPipesModule} from "ngx-pipes";
import {RegraModule} from "../regra/regra.module";
import {SharedModule} from "../shared/shared.module";
import {TrilhaAuditoriaComponent} from "./trilha-auditoria.component";
import {TrilhaAuditoriaPesquisaComponent} from './trilha-auditoria-pesquisa/trilha-auditoria-pesquisa.component';

@NgModule({
  declarations: [TrilhaAuditoriaPesquisaComponent, TrilhaAuditoriaComponent, ModalAlteracoesComponent],
  imports: [
    CommonModule,
    TabsModule,
    ReactiveFormsModule,
    CarteiraModule,
    MatRadioModule,
    RegraModule,
    SharedModule,
    DatepickerModule,
    MatSelectModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    PaginationMapsModule,
    PaginationModule,
    FormsModule,
    NgStringPipesModule,
    AutocompleteModule,
    MatCheckboxModule,
    MatInputModule,
  ],
  providers: [DatePipe, DecimalPipe],
  exports: [TrilhaAuditoriaComponent],
})
export class TrilhaAuditoriaModule {
}
